<template>
  <article class="voice-advice__create iv-p-t-24 iv-p-b-40">
    <div class="iv-main-width">
      <!--步骤看板-->
      <ApplyStep v-if="type != 'see'" :stepData="stepData" />
      <!-- <BulletinBoard style="height: 180px;" v-for="(item, index) in boardList" :key="index" :data="item"></BulletinBoard> -->
      <VoicePanel title="心声建议"></VoicePanel>
      <LayoutTitle title="">
      <FormLayout 
        ref="personAdviceInfo"
        :readOnly="readOnly"
        :model="personAdviceModel" 
        :list="personAdviceFormOptions"
        @on-change="handleChange"
        >
      </FormLayout>
      </LayoutTitle>
      <LayoutTitle title="附件信息">
        <FormLayout
          ref="attachmentInfo"
          :readOnly="readOnly"
          :model="attachmentModel"
          :list="attachmentOptions">
        </FormLayout>
      </LayoutTitle>
      <FooterOperator>
        <div class="iv-text-center">
          <span  v-if="type != 'see'">
            <Button 
            class="iv-m-r-8" 
            type="save" 
            @click="handleSave">
            保存
          </Button>
          <Button 
            class="iv-m-r-8" 
            type="submit" 
            @click="handleSubmit">
            提交
          </Button>
          </span>
          <Button 
            type="back" 
            @click="handleClickBack">
            返回
          </Button>
        </div>
      </FooterOperator>
    </div>
  </article>
</template>

<script>
import ApplyStep from '../components/apply-step.vue'
import VoicePanel from '../components/panel.vue'
import formOptions, { attachmentOptions } from './formOptions'
import FormLayout from '@/components/layout/form'
import LayoutTitle from '@/components/layout/layout-title'
import FooterOperator from '@/components/footer-operator'
import DragTable from '@/components/drag-table-inline'
import BulletinBoard from '@/components/bulletin-board-list'
import { timeFormat } from '@/utils'
import columns from './columns'
export default {
  name: 'createVoiceAdvice',
  components: { 
    ApplyStep,
    DragTable,
    VoicePanel, 
    FormLayout, 
    LayoutTitle, 
    FooterOperator,
    BulletinBoard
  },
  data () {
    return {
      orgId: sessionStorage.getItem('orgId'),
      orgName: sessionStorage.getItem('fullName'),
      personAdviceFormOptions: [],
      personAdviceModel: {
        adviceTime: timeFormat(new Date()),
        orgName: sessionStorage.getItem('fullName')
      },
      attachmentOptions: [],
      attachmentModel: {},
      getTypeCodesOptionList: [],
      voiceAdviceId: this.$route.query.voiceAdviceId,
      groupId: '',
      type: this.$route.query.type,
      readOnly: false,
      files: [],
      getUploadFiles: [],
      columns: [],
      tableData: [],
      stepData: [
        {
          step: 1,
          status: 'auditing',
          title: '心声建议提交'
        },
        {
          step: 2,
          status: 'wait',
          title: '心声建议接收'
        },
        {
          step: 3,
          status: 'wait',
          title: '心声建议处理'
        },
        {
          step: 4,
          status: 'wait',
          title: '处理结果审核'
        },
        {
          step: 5,
          status: 'wait',
          title: '心声建议反馈'
        }
      ],
      url: '',
      method: ''
    }
  },
  async created () {
    if(this.voiceAdviceId && this.type == 'see') {
      this.readOnly = true
      this.getVoiceAdvice()
      this.getlistAudit()
    } else if( this.voiceAdviceId && this.type == 'edit') {
      this.getVoiceAdvice()
    } else {
      this.groupId = this.getUuid()
    }
    await this.getTypeCodesList()
  },
  methods: {
    handleChange(val) {
      let indexTypeCodes = this.personAdviceFormOptions.findIndex(item => {
        return item.key == 'typeCodes'
      })
      let indexOtherTypeDesc = this.personAdviceFormOptions.findIndex(item => {
        return item.key == 'otherTypeDesc'
      })
      if(this.personAdviceModel.typeCodes.length != 0) {
        let indexCodes = this.personAdviceModel.typeCodes.findIndex(item => {
          return item == 'X04'
        })
        if(indexCodes != -1) {
          if(indexOtherTypeDesc == -1) {
            this.personAdviceFormOptions.splice(indexTypeCodes + 1, 0 , {
              type: 'Input',
              title: '其他类型描述',
              colSpan: 8,
              [$field]: 'otherTypeDesc',
              rules: ['required'],
            })
          }
        } else {
          if(indexOtherTypeDesc != -1) {
            this.personAdviceFormOptions.splice(indexOtherTypeDesc, 1)
          }
        }
      } else {
        if(indexOtherTypeDesc != -1) {
          this.personAdviceFormOptions.splice(indexOtherTypeDesc, 1)
        }
      }
    },
    // 查询心声建议详情
    getVoiceAdvice () {
      this.$ajax({
        url :'api-general/module/portal/voiceAdvice/get',
        method: 'GET',
        data: {
          voiceAdviceId: this.voiceAdviceId
        }
      }).then(data => {
        let res = data.data.data
        this.personAdviceModel = res
        this.personAdviceModel.adviceTime = timeFormat(this.personAdviceModel.adviceTime)
        this.groupId = this.personAdviceModel.fileInfo || this.getUuid()
        this.columns = columns.call(this)
        this.getActivityFiles(this.groupId)
      })
    },
    // 办理过程查询
    getlistAudit () {
      this.$ajax({
        url: 'api-general/module/portal/voiceAdvice/listAudit',
        method: 'GET',
        data: {
          voiceAdviceId: this.voiceAdviceId
        }
      }).then(data => {
        let res = data.data.data
        this.tableData = res
      })
    },
    // 新增心声建议
    addVoiceAdvice (isSubmit, type) {
      this.$refs.personAdviceInfo.validate((valid) => {
        if (!valid) {
          return this.$Message.error('校验未通过')
        }
        if(type == 'add') {
          this.url = 'api-general/module/portal/voiceAdvice/add'
          this.method = 'POST'
        } else if(type == 'update') {
          this.url = 'api-general/module/portal/voiceAdvice/update'
          this.method = 'PUT'
        }
        this.personAdviceModel.adviceTime = timeFormat(this.personAdviceModel.adviceTime)
        this.$ajax({
          url: this.url,
          method: this.method,
          data: {
            ...this.personAdviceModel,
            isSubmit: isSubmit,
            fileInfo: this.groupId,
            voiceAdviceId: this.voiceAdviceId
          }
        }).then(data => {
          if(isSubmit == 'no') {
            this.$Message.success('保存成功')
          } else {
            this.$Message.success('提交成功')
          }
          this.$router.push({
            name: 'voiceAdviceList',
            query: {
              currentPage: this.$route.query.currentPage || 1,
              tabName: this.$route.query.tabName || ''
            }
          })
        })})
    },
    //获取附件id 第一次上传附件 本地生产uuid
    getUuid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    getActivityFiles (groupId) {
      this.$ajax({
        url: 'api-uum/file/listFilesByGroupId',
        method: 'GET',
        data: {
          isPage: false,
          groupId: groupId
        }
      }).then(({data}) => {
        this.files = data.data
        this.$set(this.attachmentModel, 'fileInfo', data.data)
        this.personAdviceFormOptions = formOptions.call(this)
        this.attachmentOptions = attachmentOptions.call(this)
      })
    },
    downLoad (item) {
      let url = `api-uum/file/downloadFile?fileId=${item.fileId}&access_token=${sessionStorage.getItem('token')}`
      window.open(url)
    },
    getTypeCodesList() {
      this.$ajax({
        url: 'api-general/module/portal/user/outGetList',
        method: 'GET',
        data: {
          dictCode: 'GG68',
          merge: false,
          bizLineCode: 'YWX03'
        }
      }).then(res => {
        res.data.data.forEach(item => {
          this.getTypeCodesOptionList.push({
            label: item.title,
            value: item.value
          })
        })
        this.personAdviceFormOptions = formOptions.call(this)
        this.attachmentOptions = attachmentOptions.call(this)
      })
    },
    // 提交
    handleSubmit () {
      const promiseList = [this.$refs.personAdviceInfo.validateify(), this.$refs.attachmentInfo.validateify()]
      Promise.all(promiseList).then(data => {
        const result = data.every(v => v === true)
        if (!result) {
          return this.$Message.error('校验未通过')
        }
        if(this.type == 'edit') {
          this.addVoiceAdvice('yes', 'update')
        } else {
          this.addVoiceAdvice('yes', 'add')
        }
      })
    },
    // 保存
    handleSave () {
      if(this.type == 'edit') {
        this.addVoiceAdvice('no', 'update')
      } else {
        this.addVoiceAdvice('no', 'add')
      }
    },
    handleClickBack () {
      this.$router.push({ 
        name: 'voiceAdviceList',
        query: {
          currentPage: this.$route.query.currentPage || 1,
          voiceCurrentPage: this.$route.query.voiceCurrentPage || 1,
          tabName: this.$route.query.tabName || ''
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.voice-advice__create {
  min-height: 100%;
  background-color: #fff;
}
</style>